import React from "react";
import PanelCustom from "../../../features/PanelCustom";
import Basket from "../Basket";
import useTypeSale from "../../../utils/hooks/useTypeSale";
import { BasketItem } from "../../models/BasketItem";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";

interface IProps {
  basket: BasketItem[];
  onRemoveBasket: (value: number) => void;
  title?: string;
}

const BasketPanel: React.FC<IProps> = ({ basket, onRemoveBasket, title = "Twój Koszyk" }: IProps) => {
  const { colorClass } = useTypeSale();
  const isDesktop = useDesktopSize();
  return (
    <>
      {isDesktop ? (
        <PanelCustom title={title}>
          {basket.length > 0 ? (
            <Basket colorClass={colorClass} basket={basket} onRemoveToBasket={onRemoveBasket} isWide />
          ) : (
            <p>Koszyk jest pusty, wróc do sklepu</p>
          )}
        </PanelCustom>
      ) : (
        <Basket colorClass={colorClass} basket={basket} onRemoveToBasket={onRemoveBasket} isWide />
      )}
    </>
  );
};

export default BasketPanel;
